import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { validateEnvironment } from '@/lib/env-validator';

// Security: Environment variables are required - no hardcoded fallbacks
// This prevents credentials from being exposed in the browser bundle
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validate environment variables are present
if (!SUPABASE_URL) {
  throw new Error('VITE_SUPABASE_URL environment variable is required. Please set it in your .env file or deployment configuration.');
}

if (!SUPABASE_PUBLISHABLE_KEY) {
  throw new Error('VITE_SUPABASE_ANON_KEY environment variable is required. Please set it in your .env file or deployment configuration.');
}

// Additional security validation
if (SUPABASE_URL.includes('localhost') && import.meta.env.PROD) {
  throw new Error('Production environment cannot use localhost Supabase URL');
}

if (SUPABASE_PUBLISHABLE_KEY.length < 100) {
  throw new Error('VITE_SUPABASE_ANON_KEY appears to be invalid (too short)');
}

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: typeof window !== 'undefined' ? localStorage : undefined,
    persistSession: true,
    autoRefreshToken: true,
  }
});